import React from "react";
import PropTypes from "prop-types";
import { Divider, Paper, Typography, Button } from "@mui/material";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";

const ServiceItem = (props) => {

  const navigate = useNavigate();
  const { name, icon,  services } = props;
  return (
    <Paper
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "1rem",
        boxShadow: "0 15px 35px  #6699ff",
        borderRadius: "4px",
        border: "solid 1px  #6699ff",
        height: "auto",
        width: isMobile ? "90%" : "400px",
        margin: "0 auto",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "75px",
          height: "75px",
          margin: ".5rem auto",
          borderRadius: "50%",
          boxShadow: "0 15px 35px rgba(8, 160, 105, 0.2)",
        }}
      >
        <img style={{ width: "100px" }} src={icon} alt={name} />
      </div>
      <Typography
        sx={{
          fontWeight: 700,
          marginTop: ".5rem",
          textTransform: "uppercase",
          marginBottom: "1rem",
        }}
        variant="h6"
      >
        {name}
      </Typography>

      {services.map((serv) => {
        return (
          <>
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                color: "green",
                margin: "0 auto",
              }}
            >
              {" "}
              <CheckIcon sx={{ marginRight: "1rem" }} />
              <Typography sx={{ color: "#000" }}>{serv.nombre}</Typography>{" "}
            </div>
            <Divider />
          </>
        );
      })}
      <Button
        sx={{ fontWeight: 700, backgroundColor: "#6699ff", marginTop: "1rem" }}
        variant="contained"
        href={"/#contacto"}
      >
        Más información
      </Button>
    </Paper>
  );
};

ServiceItem.propTypes = {
  name: PropTypes.string.isRequired,
   icon:PropTypes.string.isRequired, 
   services:PropTypes.shape({
    nombre: PropTypes.string
  }),
};

export default ServiceItem;
